module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "base-container",
    class: {
      noPageHd: !_vm.isPageHd,
      noMainHd: !_vm.isMainHd,
      noPageFt: !_vm.isHasPageFt,
    }
  }, [(_vm.isPageHd) ? _c('header', {
    staticClass: "base-container-hd"
  }, [_c('span', {
    staticClass: "arrow"
  }), _vm._v(" " + _vm._s(_vm.getCurMenu))]) : _vm._e(), _vm._v(" "), [_c('main', {
    staticClass: "base-container-bd"
  }, [_c('header', {
    staticClass: "content-hd"
  }, [_vm._t("hd")], 2), _vm._v(" "), _c('section', {
    staticClass: "content-bd"
  }, [_vm._t("main")], 2)]), _vm._v(" "), (_vm.isHasPageFt) ? _c('footer', {
    staticClass: "base-container-ft"
  }, [_vm._t("ft")], 2) : _vm._e()]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c81f1e0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BaseContainer.vue
// module id = 1714
// module chunks = 9